(() => {
  'use strict';
  if (customElements.get('garrnish-supply')) return;
  const P = window.HouseholdPlanner;
  const S = window.GarrnishSelect;
  const escapeHTML = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const START_EVENTS = ['pointerdown', 'touchstart', 'focusin', 'keydown'];
  class GarrnishSupply extends HTMLElement {
    // Starts once the page has loaded and is idle, or sooner if the panel nears the screen or is touched,
    // so a panel lower on the page doesn't slow the page load but is ready (cart read) before anyone reaches it.
    connectedCallback() {
      if (this.controller || this.startObserver) return;
      if (window.Shopify?.designMode || !('IntersectionObserver' in window)) return this.init();
      this.start = () => {
        this.stopWaiting();
        if (this.isConnected) this.init();
      };
      this.startObserver = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) this.start(); }, {rootMargin: '800px 0px'});
      this.startObserver.observe(this);
      START_EVENTS.forEach(type => this.addEventListener(type, this.start, {capture: true, passive: true}));
      this.startWhenIdle = () => {
        if (!this.startObserver) return;
        const id = 'requestIdleCallback' in window ? window.requestIdleCallback(this.start, {timeout: 2000}) : window.setTimeout(this.start, 200);
        this.cancelIdle = () => ('requestIdleCallback' in window ? window.cancelIdleCallback(id) : window.clearTimeout(id));
      };
      if (document.readyState === 'complete') this.startWhenIdle();
      else window.addEventListener('load', this.startWhenIdle, {once: true});
    }
    stopWaiting() {
      this.startObserver?.disconnect(); this.startObserver = null;
      START_EVENTS.forEach(type => this.removeEventListener(type, this.start, {capture: true}));
      window.removeEventListener('load', this.startWhenIdle);
      this.cancelIdle?.(); this.cancelIdle = null;
    }
    init() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.cleanups = [];
      this.selectionVersion = 0;
      this.cartRevision = 0;
      this.loadingCart = true;
      this.editKey = new URLSearchParams(location.search).get('garrnish_edit');
      const options = {signal: this.controller.signal};
      this.form = this.querySelector('[data-supply-subscription]');
      this.onceForm = this.querySelector('[data-supply-once]');
      try {
        this.config = JSON.parse(this.querySelector('[data-supply-config]').textContent);
        P.configurePrice(this.variant()?.price);
        this.dogs = JSON.parse(this.config.dogs);
        this.size = this.querySelector('.gs__size input:checked')?.value || 'medium';
        this.sizes = [''];
        this.selectionConfirmed = false;
        this.offer = 'value';
        this.purchaseMode = 'subscription';
        this.offers = {};
        for (const size of ['small','medium','large']) {
          const card = this.querySelector(`[data-dog="${size}"]`);
          card.querySelector('[data-dog-label]').textContent = this.dogs[size].label;
          card.querySelector('[data-dog-weight]').textContent = this.dogs[size].weight;
          const rows = P.recommend(P.countsFromSizes([size])).options;
          this.offers[size] = {value: this.row(rows[0]), recommended: this.row(rows[1])};
        }
        this.weeks = null;
        this.addEventListener('change', event => {
          if (event.target.matches('.gs__size input')) {
            this.size = event.target.value; this.sizes = [this.size]; this.selectionConfirmed = true; this.resetSupply();
          } else if (event.target.matches('[data-once-choice]')) {
            this.purchaseMode='once';
          } else if (event.target.matches('[data-household-supply]')) {
            this.purchaseMode='subscription'; this.weeks=Number(event.target.value);
          } else if (event.target.matches('.gs__offer input')) {
            this.purchaseMode='subscription';
            this.offer = event.target.value; this.weeks = this.offers[this.size][this.offer].weeks;
          } else return;
          this.update(true);
        }, options);
        this.querySelector('[data-household-widget]').addEventListener('click', () => {
          if(this.purchaseMode==='once'){this.purchaseMode='subscription';this.update(true);}
        }, options);
        this.querySelector('[data-household-add]').addEventListener('click', () => {
          if (this.sizes.length >= P.MAX_DOGS) return;
          this.selectionConfirmed = false; this.sizes.push(''); this.resetSupply(); this.renderHousehold(); this.update(true);
          this.querySelector(`[id="${this.id}-dog-${this.sizes.length-1}"]`)?.focus();
        }, options);
        this.querySelector('[data-household-single]').addEventListener('click', () => {
          this.clearHousehold();
          this.querySelector(`.gs__size input[value="${this.size}"]`)?.focus();
        }, options);
        this.querySelector('[data-household-dogs]').addEventListener('click', event => {
          const remove = event.target.closest('[data-remove-dog]'); if (!remove) return;
          this.selectionConfirmed = false; this.sizes.splice(Number(remove.dataset.removeDog), 1); this.size = this.sizes[0] || 'medium';
          this.selectionConfirmed=this.sizes.length===1 && Boolean(this.sizes[0]);
          this.resetSupply(); this.renderHousehold(); this.update(true);
          this.querySelector('[data-household-add]').focus();
        }, options);
        this.querySelector('[data-household-confirm]').addEventListener('click', () => {
          if (!this.sizes.every(size => this.dogs[size])) return;
          this.selectionConfirmed = true; this.resetSupply(); this.update(true);
          this.querySelector('[data-purchase-options]').focus({preventScroll:true});
        }, options);
        this.addEventListener('pointerdown', event => { if (event.target.closest('[type=submit]')) window.GarrnishCart.prefetch?.(); }, options);
        this.form.addEventListener('submit', event => { event.preventDefault(); event.stopImmediatePropagation(); this.purchase(this.purchaseMode==='once'); }, {...options, capture:true});
        this.onceForm.addEventListener('submit', event => { event.preventDefault(); event.stopImmediatePropagation(); this.purchase(true); }, {...options, capture:true});
        this.onceForm.addEventListener('formdata', event => { event.formData.set('quantity','1'); event.formData.delete('selling_plan'); }, options);
        this.observer = new MutationObserver(() => { this.update(false); this.syncCart(true); });
        this.observer.observe(this.form.elements.id, {attributes:true, attributeFilter:['value']});
        this.form.elements.id.addEventListener('change', () => { this.update(false); this.syncCart(true); }, options);
        const refresh = () => { if(!document.hidden) this.syncCart(); };
        document.addEventListener('garrnish:cart-updated', refresh, options);
        document.addEventListener('visibilitychange', refresh, options);
        window.addEventListener('focus', refresh, options);
        window.addEventListener('pageshow', refresh, options);
        if(typeof subscribe === 'function') this.cartUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
        this.renderHousehold(); this.update(false);
        this.syncCart(true);
        this.dispatchEvent(new CustomEvent('garrnish:supply-ready'));
      } catch (error) {
        this.form.querySelector('[type=submit]').disabled = true;
        this.onceForm.querySelector('[type=submit]').disabled = true;
        console.error('Garrnish household configuration:', error);
      }
    }
    disconnectedCallback() { this.stopWaiting(); this.controller?.abort(); this.controller=null; this.cartRevision++; this.cartUnsubscriber?.(); this.observer?.disconnect(); this.cleanups?.forEach(f => f()); this.supplyCleanup?.(); }
    t(key, values={}) { return this.replace(this.config.labels[key] || '', values); }
    h(key, values={}) { if(key==='boxes'&&values.quantity===1)return this.t('box'); return this.replace(this.config.householdLabels[key] || '', values); }
    replace(text, values) { return String(text).replace(/\{\{\s*(\w+)\s*\}\}|\{(\w+)\}|\[(\w+)\]/g,(match,a,b,c)=>Object.hasOwn(values,a||b||c)?String(values[a||b||c]):match); }
    money(cents) { return P.money(cents); }
    row(p) { return p && {...p, quantity:p.boxes, price:p.unit}; }
    variant() { return this.config.variants.find(v=>String(v.id)===this.form.elements.id.value); }
    clearHousehold() { this.sizes=['']; this.size='medium'; this.selectionConfirmed=false; this.resetSupply(); this.renderHousehold(); this.update(true); }
    resetSupply() { this.purchaseMode='subscription'; this.offer='value'; try { this.weeks=P.selectedOffer(this.sizes).weeks; } catch (_) { this.weeks=null; } }
    selected() { if(!this.selectionConfirmed)return null; try { return P.selectedOffer(this.sizes,this.weeks); } catch (_) { return null; } }
    allowedQuantity(v,q) { return v && Number.isSafeInteger(q) && q>=v.minimum && (!v.maximum || q<=v.maximum) && q%v.increment===0; }
    onceDaily() { try { return (this.variant()?.price || P.PRICE.once) * P.daily(P.countsFromSizes(this.sizes)) / 28; } catch (_) { return 0; } }
    oneTimeAllowed(v) { return Boolean(v?.available && !this.config.requiresPlan && !v.requiresPlan && this.allowedQuantity(v,1) && v.price===P.PRICE.once && this.config.currency==='SGD'); }
    plan(v,row) {
      const id = P.planId(row);
      const matches = v?.plans?.filter(a=>a.id===id && P.validAllocation(a,row)) || [];
      return matches.length===1 ? matches[0] : null;
    }
    renderHousehold() {
      this.cleanups.forEach(f=>f()); this.cleanups=[];
      const household=this.sizes.length>1;
      const fieldset=this.querySelector('.gs__sizes');
      const legend=fieldset.querySelector('[data-size-heading]');
      this.sizeHeading ??= legend.textContent;
      legend.textContent=household?this.h('build_heading'):this.sizeHeading;
      fieldset.classList.toggle('is-household',household);
      this.querySelectorAll('.gs__size').forEach(card=>card.hidden=household);
      this.querySelector('[data-household-divider]').hidden=!household;
      this.querySelector('.gs__offers').hidden=household;
      const dogs=this.querySelector('[data-household-dogs]'); dogs.hidden=!household;
      const actions=this.querySelector('[data-household-actions]'); actions.classList.toggle('is-household',household);
      const add=this.querySelector('[data-household-add]'); add.textContent=this.h(household?'add_dog':'entry'); add.disabled=this.sizes.length>=3;
      this.querySelector('[data-household-single]').hidden=!household;
      this.querySelector('[data-household-limit]').hidden=this.sizes.length<3;
      this.querySelector('[data-household-widget]').hidden=!household;
      this.querySelectorAll('.gs__size input').forEach(input=>input.checked=input.value===this.sizes[0]);
      if (!household) { dogs.replaceChildren(); return; }
      const options=Object.entries(this.dogs).map(([value,dog])=>({value,text:`${dog.label}, ${dog.weight}`,html:`<span class="size-choice"><strong>${escapeHTML(dog.label)}</strong><span>· ${escapeHTML(dog.weight.replace(/[–—]/g,'-'))}</span></span>`}));
      dogs.innerHTML=this.sizes.map((size,index)=>{
        const label=this.h('dog',{number:index+1});
        return `<div class="gh__dog-row"><span class="gh__dog-label">${escapeHTML(label)}</span>${S.markup({id:`${this.id}-dog-${index}`,label:label+' '+this.h('placeholder'),options,value:size,placeholder:this.h('placeholder')})}${`<button type="button" class="gh__remove" data-remove-dog="${index}" aria-label="${escapeHTML(this.h('remove_dog',{number:index+1}))}"><img src="https://cdn.shopify.com/s/files/1/0738/2846/6871/files/bin-Agave.svg?v=1789699626" width="20" height="20" alt=""></button>`}</div>`;
      }).join('');
      this.sizes.forEach((size,index)=>this.cleanups.push(S.mount({id:`${this.id}-dog-${index}`,options,value:size,onChange:value=>{
        this.selectionConfirmed=false; this.sizes[index]=value; this.size=this.sizes[0] || 'medium'; this.resetSupply(); this.update(true);
      }})));
    }
    pricing(row, sizes=this.sizes) {
      const matches=P.matchesSelection(this.cartItem,sizes,row,this.variant()?.id);
      if(matches && Number.isFinite(this.cartItem.final_line_price)) {
        const subtotal=this.cartItem.final_line_price;
        return {...P.subscriptionPrice(row,this.cartItem.selling_plan_allocation),amount:P.PRICE.once-subtotal/row.boxes,unit:subtotal/row.boxes,subtotal,saving:Math.floor((1-subtotal/row.boxes/P.PRICE.once)*100)};
      }
      const allocation=this.plan(this.variant(),row);
      // Missing/invalid plans cannot be purchased; never invent a discounted quote.
      return P.subscriptionPrice(row,allocation || {price:this.variant()?.price || P.PRICE.once});
    }
    ctaHTML(fallback, sticky=false) {
      if(this.busy) {
        const key=this.busyAction==='update'?'loading_update':this.busyAction==='view'?'loading_checkout':'loading_add';
        return `<span class="gc-action-spinner" aria-hidden="true"></span><span class="${sticky && this.busyAction==='view'?'gc-sticky-checkout-loading-copy':''}">${escapeHTML(this.h(key))}</span>`;
      }
      if(this.cartSyncFailed||(this.purchaseMode!=='once'&&this.cartAmbiguous))return escapeHTML(this.h('view_cart'));
      if(!this.variant()?.available)return escapeHTML(this.t('sold_out'));
      if(this.purchaseMode==='once')return escapeHTML(this.h(this.cartAction==='view'?'checkout_mobile':this.cartAction==='update'?'update_mobile':'once_add_to_cart'));
      const key=this.cartAction==='view'?'checkout_mobile':this.cartAction==='update'?'update_mobile':null;
      const label=key?this.h(key):fallback;
      const row=this.selected();
      const saving=row?row.boxes*P.PRICE.once-this.pricing(row).subtotal:0;
      return escapeHTML(label)+(saving>0?`<span class="gc-action-saving"><span class="gc-action-separator" aria-hidden="true">|</span>${escapeHTML(this.h('save_amount',{price:this.money(saving).replace(/\.00$/,'')}))}</span>`:'');
    }
    monthly(price,row) { return Math.round(price.subtotal*28/row.days); }
    savingPillHTML(price) {
      return `<span class="gh__banner gh__banner--saving" data-volume="${price.volume}"><span>${escapeHTML(this.h('saving',{percent:price.saving}))}</span></span>`;
    }
    benefitSavings(price, row) {
      const savings=this.money(row.boxes*P.PRICE.once-price.subtotal).replace(/\.00$/,'');
      return `${this.h('save_amount',{price:savings})} + FREE delivery on every order`;
    }
    billing(row, price) {
      return this.h('billing_current',{price:this.money(price.subtotal),weeks:row.weeks});
    }
    // A household supply card, built like the single-dog cards in custom-purchase-panel.liquid.
    supplyCardHTML(row, recommended, checked, check) {
      const price=this.pricing(row);
      const benefits=[this.benefitSavings(price,row),this.h('benefit_guarantee'),this.h('benefit_flexibility')];
      return `<label class="gs__offer gs__offer--${recommended?'value':'recommended'}" data-volume="${price.volume}">`+
        (recommended?`<span class="gs__corner">${escapeHTML(this.h('best_value_current',{percent:price.saving}))}</span>`:'')+
        `<span class="gs__card-top"><span class="gs__card-identity"><span class="gs__offer-heading"><input type="radio" name="supply-${this.config.sectionId}" value="${row.weeks}" data-household-supply${checked?' checked':''}><span class="gs__title-row"><strong class="gs__duration">${escapeHTML(this.h('weeks',row))}</strong><span class="gh__pill-slot">${this.savingPillHTML(price)}</span></span></span>`+
        `<span class="gs__delivery-summary">${escapeHTML(this.h('household_row',{price:this.money(price.subtotal),weeks:row.weeks,boxes:this.h('boxes',{quantity:row.boxes}).trim().replace(/ /g,'\u00a0')}))}</span></span>`+
        `<span class="gs__card-pricing"><span class="gs__price-row"><strong>${escapeHTML(this.money(this.monthly(price,row)))}</strong><span>${escapeHTML(this.h('card_per_month'))}</span></span><span class="gs__daily-line">${this.money(price.subtotal/row.days)} ${escapeHTML(this.h('card_per_day'))}</span></span></span>`+
        `<span class="gs__benefits">${benefits.map(text=>`<span>${check}<span>${escapeHTML(text)}</span></span>`).join('')}</span>`+
        // Same clinical note as the single-dog Best Value card, on the household Best Value card when it's an 8- or 12-week supply.
        (recommended&&row.weeks>=8&&row.weeks<=12?`<span class="gs__clinical-note">${escapeHTML(this.h('clinical_note'))}</span>`:'')+
        `</label>`;
    }

    renderSupply(row) {
      const key=JSON.stringify([this.sizes,row?.weeks,this.purchaseMode,this.cartItem?.key,this.cartItem?.final_line_price]);
      if(this.supplyKey===key)return;
      this.supplyKey=key;
      const widget=this.querySelector('[data-household-widget]');
      if (this.sizes.length===1) return;
      widget.classList.toggle('is-pending',!row);
      const title='';
      if (!row) { widget.innerHTML=title+`<p class="gh__pending">${escapeHTML(this.h('pending'))}</p>`; return; }
      const recommendation=P.recommend(P.countsFromSizes(this.sizes));
      const check=this.querySelector('.gs__benefits svg')?.outerHTML || '';
      // At most one card per price tier: the shortest 3+ box supply (25%, with the ribbon), then the shortest
      // 1-2 box supply (12%). A plan being edited from the cart stays visible even if it's neither.
      const volume=recommendation.options.find(p=>p.boxes>=3), basic=recommendation.options.find(p=>p.boxes<3);
      const rows=[volume,basic].filter(Boolean);
      if(!rows.some(p=>p.weeks===row.weeks))rows.push(row);
      widget.innerHTML=rows.map((p,i)=>this.supplyCardHTML(p,i===0,this.purchaseMode!=='once'&&p.weeks===row.weeks,check)).join('');
    }
    update(announce) {
      if(announce){this.selectionVersion++;this.showError('');}
      this.querySelector('[data-start-prompt]').hidden=this.selectionConfirmed||this.sizes.length>1;
      this.querySelector('[data-purchase-options]').hidden=!this.selectionConfirmed;
      const confirm=this.querySelector('[data-household-confirm]');
      confirm.hidden=this.sizes.length<2 || this.selectionConfirmed;
      confirm.disabled=!this.sizes.every(size=>this.dogs[size]);
      this.querySelector('[data-selection-help]').hidden=this.selectionConfirmed;
      const v=this.variant(), row=this.selected(); P.configurePrice(v?.price); this.activeRow=this.row(row);
      this.activePlan=row?this.plan(v,row):null;
      this.onceForm.elements.id.value=v?String(v.id):''; this.onceForm.elements.quantity.value='1';
      this.onceForm.querySelector('[type=submit]').disabled=this.busy||!this.selectionConfirmed||!this.oneTimeAllowed(v);
      this.querySelector('[data-once-choice]').checked=this.purchaseMode==='once';
      this.querySelector('[data-once-total]').textContent=this.h('once_current',{price:this.money(v?.price||P.PRICE.once),delivery:this.money(P.PRICE.shipping).replace(/\.00$/,'')});
      this.querySelector('[data-once-price]').textContent=this.money(v?.price||P.PRICE.once);
      this.querySelector('[data-once-daily]').textContent=this.money(this.onceDaily());
      this.querySelector('[data-once-label]').textContent=this.t('once',{price:this.money(v?.price||P.PRICE.once)});
      const note=this.querySelector('[data-recommendation]'); note.hidden=!this.selectionConfirmed||this.sizes.length>1;
      note.textContent=this.t('recommendation',{size:this.dogs[this.size].label.toLowerCase(),dose:this.dogs[this.size].dose,weeks:this.offers[this.size].value.weeks});
      for(const key of ['value','recommended']) {
        const p=this.offers[this.size][key], price=this.pricing(p,[this.size]), card=this.querySelector(`[data-offer="${key}"]`);
        const put=(field,value)=>{const el=card.querySelector(`[data-field="${field}"]`);if(el)el.textContent=value;};
        // Same radio group as the household cards: tick a single-dog card only when one dog is chosen.
        card.querySelector('input').checked=this.sizes.length===1&&this.purchaseMode!=='once'&&key===this.offer;
        put('weeks',this.t('weeks',p)); put('price',this.money(this.monthly(price,p)));
        put('saving',this.t('saving',{percent:price.saving}));
        put('benefit-savings',this.benefitSavings(price,p));
        const ribbon=card.querySelector('.gs__corner');if(ribbon)ribbon.textContent=this.h('best_value_current',{percent:price.saving});
        card.querySelector('[data-field=banners]').innerHTML=this.savingPillHTML(price);
        put('serving',this.money(price.subtotal/p.days));
        put('delivery',this.billing(p,price));
        card.dataset.volume=String(price.volume);
        const clinical=card.querySelector('.gs__clinical-note');
        // The note recommends 8–12 weeks, so the 24-week supply (small dogs) goes without it.
        if(clinical)clinical.hidden=p.weeks>12;
      }
      const subscriptionValid=Boolean(row && v?.available && this.allowedQuantity(v,row.boxes) && this.activePlan && this.config.ready && this.config.currency==='SGD' && !this.loadingCart);
      const valid=this.purchaseMode==='once'?Boolean(this.selectionConfirmed&&this.oneTimeAllowed(v)&&!this.loadingCart):subscriptionValid;
      this.form.elements.quantity.value=this.purchaseMode==='once'?'1':row?String(row.boxes):'0';
      this.form.elements.selling_plan.value=this.purchaseMode!=='once'&&this.activePlan?String(this.activePlan.id):'';
      this.form.elements.selling_plan.disabled=this.purchaseMode==='once'||!subscriptionValid;
      this.form.querySelector('[type=submit]').disabled=!valid||this.busy;
      this.querySelector('.gs__checkout-discount').hidden=this.purchaseMode==='once';
      this.cartAction=this.purchaseAction();
      const addLabel=this.querySelector('[data-add-label]');
      const ctaLabel=this.ctaHTML(!v?.available?this.t('sold_out'):this.h('add_to_cart'));
      if(addLabel.innerHTML!==ctaLabel)addLabel.innerHTML=ctaLabel;
      this.form.querySelector('[type=submit]').dataset.cartAction=this.cartAction;
      this.form.querySelector('[type=submit]').setAttribute('aria-busy',String(Boolean(this.busy)));
      const notice=this.querySelector('[data-plan-notice]'); notice.hidden=valid||!row||this.loadingCart; if(!valid&&row)notice.textContent=this.h('configuration');
      this.renderSupply(row);
      this.querySelectorAll('[data-household-supply]').forEach(input=>{input.checked=this.purchaseMode!=='once'&&Number(input.value)===row?.weeks;});
      this.querySelector('[data-household-widget]').classList.toggle('is-unselected',this.purchaseMode==='once');
      this.dispatchEvent(new CustomEvent('garrnish:supply-change',{bubbles:true}));
      if(announce) {
        this.querySelector('[data-announcement]').textContent=this.purchaseMode==='once'?this.h('once_title'):row?this.billing(row,this.pricing(row)):this.h('pending');
        if(row) this.dispatchEvent(new CustomEvent('garrnish:household-selection',{bubbles:true,detail:{...P.countsFromSizes(this.sizes),total_dogs:this.sizes.length,household_segment:P.properties(this.sizes,row)._garrnish_segment,weeks:row.weeks,box_quantity:row.boxes}}));
      }
      return valid;
    }
    purchaseAction() {
      if(this.cartSyncFailed)return 'view';
      const once=this.onceItems||[];
      // A cart holds a subscription or one-time boxes, never both: choosing the other kind replaces it.
      if(this.purchaseMode==='once') {
        if(this.cartItem||this.cartAmbiguous)return 'update';
        if(!once.length)return 'add';
        return once.length===1&&once[0].properties?._garrnish_sizes===this.sizes.join(',')?'view':'update';
      }
      if(this.cartAmbiguous)return 'view';
      if(once.length)return 'update';
      if(!this.cartItem || Number(this.cartItem.variant_id)!==Number(this.variant()?.id))return 'add';
      return P.matchesSelection(this.cartItem,this.sizes,this.selected(),this.variant()?.id)?'view':'update';
    }
    receiveCart(cart, restore=false) {
      this.cartSyncFailed=false;
      this.cartHasItems=cart.items.some(item=>item.quantity>0);
      const following=this.purchaseMode!=='once'&&P.matchesSelection(this.cartItem,this.sizes,this.selected(),this.variant()?.id);
      const existing=cart.items.filter(item=>P.managed(item)&&String(item.variant_id)===String(this.variant()?.id));
      const item=existing.find(item=>item.key===(this.editKey||this.cartItem?.key))||(existing.length===1?existing[0]:null);
      this.cartItem=item;
      this.onceItems=cart.items.filter(line=>!line.selling_plan_allocation&&line.quantity>0&&String(line.variant_id)===String(this.variant()?.id));
      this.cartAmbiguous=Boolean(item && !P.editablePlan(item.selling_plan_allocation?.selling_plan?.id)) || cart.items.some(line=>line.selling_plan_allocation&&line.key!==item?.key);
      if(item&&this.purchaseMode!=='once'&&(restore||following)) {
        try {
          const saved=P.restore(item,true);
          this.selectionConfirmed=true;
          if(this.sizes.join(',')!==saved.sizes.join(',')||this.weeks!==saved.row.weeks) {
            this.sizes=saved.sizes;this.size=this.sizes[0];this.weeks=saved.row.weeks;
            this.offer=this.weeks===this.offers[this.size].value.weeks?'value':'recommended';
            this.renderHousehold();
          }
        } catch (_) {}
      }
      if(this.editKey) {
        this.editKey=null;
        const url=new URL(location.href);url.searchParams.delete('garrnish_edit');history.replaceState(null,'',url);
      }
    }
    async syncCart(restore=false) {
      if(this.busy)return;
      const revision=++this.cartRevision, selectionVersion=this.selectionVersion;
      const restoreSelection=restore||((this.loadingCart||this.cartSyncFailed)&&selectionVersion===0);
      let received=false;
      try {
        const cart=await window.GarrnishCart.read();
        if(revision!==this.cartRevision||this.busy)return;
        if(this.cartSyncFailed)this.showError('');
        this.receiveCart(cart,restoreSelection&&selectionVersion===this.selectionVersion);
        received=true;
        this.loadingCart=false;this.update(false);
      } catch (error) {
        if(revision!==this.cartRevision||this.busy)return;
        if(!received) {
          this.cartSyncFailed=true;
          this.cartHasItems ||= Boolean(document.querySelector('cart-drawer .cart-item'));
          this.showError(this.h('cart_error'));
        }
        console.warn('Garrnish cart synchronization failed:',error);
      }
      finally {if(revision===this.cartRevision){this.loadingCart=false;this.update(false);}}
    }
    async openCart() {
      if(this.busy)return;
      this.showError('');
      try {await window.GarrnishCart.open();}
      catch(error){this.showError(error.message||this.h('cart_error'));}
    }
    showError(text) {const el=this.querySelector('[data-household-error]');el.textContent=text;el.hidden=!text;}
    async purchase(once) {
      if(this.busy||!this.selectionConfirmed)return;
      window.GarrnishCart.prefetch?.();
      if(once!==(this.purchaseMode==='once')||!this.update(false))return;
      if(this.cartSyncFailed){await this.openCart();await this.syncCart();return;}
      this.showError('');
      const row=this.selected(), sizes=[...this.sizes], variant=this.variant();
      const intent=this.purchaseAction();
      this.cartRevision++;
      this.busyAction=intent;this.busy=true;this.update(false);
      const submit=(once?this.onceForm:this.form).querySelector('[type=submit]');submit.setAttribute('aria-busy','true');
      let navigating=false;
      try {
        let action;
        const result=await window.GarrnishCart.write(cart=>{
          this.receiveCart(cart);
          action=this.purchaseAction();
          if(intent==='view'||action==='view'||intent!==action)return null;
          const onceLines=this.onceItems||[];
          if(once) {
            // Keep the number of one-time boxes; edit the line that already has these dogs (or the first one),
            // so Shopify never merges lines, then remove every other line of this product.
            const editing=onceLines.find(line=>line.properties?._garrnish_sizes===sizes.join(','))||onceLines[0]||null;
            const quantity=onceLines.reduce((sum,line)=>sum+line.quantity,0)||1;
            const remove=cart.items.filter(line=>String(line.variant_id)===String(variant.id)&&line.key!==editing?.key).map(line=>line.key);
            return {item:{id:variant.id,quantity,properties:P.dogProperties(sizes)},editing,remove};
          }
          const editing=this.cartItem;
          const item={id:variant.id,quantity:row.boxes,properties:{...(editing?.properties||{}),...P.properties(sizes,row)},selling_plan:P.planId(row)};
          return {item,editing,remove:onceLines.map(line=>line.key)};
        });
        if(!result) {
          const unchanged=once?action==='view':P.matchesSelection(this.cartItem,sizes,row,variant.id);
          if(intent==='view'&&action==='view'&&!this.cartAmbiguous&&unchanged)navigating=await window.GarrnishCart.checkout();
          else await window.GarrnishCart.open();
          return;
        }
        if(!once){
          const added=result.items.find(i=>P.matchesSelection(i,sizes,row,variant.id));
          if(!added)throw new Error(this.h('configuration'));
          this.cartItem=added;
        }
        this.receiveCart(result);
        window.GarrnishCart.present(result);
      } catch(error) {
        try { this.receiveCart(await window.GarrnishCart.read()); await window.GarrnishCart.open(); } catch (_) {}
        this.showError(error.message||this.h('cart_error'));
      }
      finally {
        const restore=()=>{this.busy=false;this.busyAction=null;submit.removeAttribute('aria-busy');this.update(false);};
        if(navigating)window.addEventListener('pageshow',restore,{once:true});else restore();
      }
    }
  }
  customElements.define('garrnish-supply',GarrnishSupply);
})();
